export default async function generateRemoteConfigUrl(getBuildMetadata) {
    const { build } = await getBuildMetadata();
    return `https://remote-config.exodus.io/v1/${encodeURIComponent(build)}.json`;
}
